module.exports = __webpack_public_path__ + "static/media/an-post.7f7276fa.png";